document.addEventListener("DOMContentLoaded", function () {

    const popup = document.getElementById("cpVideoPopup");
    const openBtn = document.getElementById("cpVideoOpen");
    const closeBtn = document.getElementById("cpVideoClose");

    if (!popup || !openBtn) return;

    const overlay = popup.querySelector(".cp-video-overlay");
    const iframe = document.getElementById("cpYoutubeFrame");
    const video = popup.querySelector("video");

    function getYoutubeID(url) {

        if (!url) return "";

        let id = "";

        if (url.includes("youtu.be/")) {
            id = url.split("youtu.be/")[1];
        }
        else if (url.includes("watch?v=")) {
            id = url.split("watch?v=")[1];
        }
        else if (url.includes("/shorts/")) {
            id = url.split("/shorts/")[1];
        }

        if (id.includes("&")) {
            id = id.split("&")[0];
        }

        return id;
    }

    openBtn.addEventListener("click", function () {

        popup.classList.add("active");

        if (iframe && window.cpYoutubeURL) {

            const videoID = getYoutubeID(window.cpYoutubeURL);

            iframe.src =
                "https://www.youtube.com/embed/" +
                videoID +
                "?autoplay=1&rel=0";

        }

        if (video) {

            video.play();

        }

    });

    function closeVideo() {

        popup.classList.remove("active");

        if (iframe) {

            iframe.src = "";

        }

        if (video) {

            video.pause();

            video.currentTime = 0;

        }

    }

    closeBtn.addEventListener("click", closeVideo);

    overlay.addEventListener("click", closeVideo);

    document.addEventListener("keydown", function (e) {

        if (e.key === "Escape") {

            closeVideo();

        }

    });

});